// Beat fills offered on the Beat Board (Final Draft 13 template swatches). These are story
// content the writer picks, so they stay the same in every appearance.
export const BEAT_COLORS = ['#63A7EF', '#9AAEDB', '#AF93E8', '#E298DD', '#EB627B', '#EFA462', '#E5CB6C', '#8FC36A', '#88CAB8', '#B27C73', '#C0C0C0'];

// Black or white text, whichever reads on a beat's fill
export const readableTextOn = (hex: string) => {
    const n = parseInt(hex.slice(1), 16);
    const luminance = (0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255;
    return luminance > 0.55 ? '#111111' : '#FFFFFF';
};
